import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronRightDoubleS1: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.53 6.47L13.06 12l-5.53 5.53-1.06-1.06L10.94 12 6.47 7.53l1.06-1.06zm5 0L18.06 12l-5.53 5.53-1.06-1.06L15.94 12l-4.47-4.47 1.06-1.06z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ChevronRightDoubleS1.displayName = 'ChevronRightDoubleS1';
export default ChevronRightDoubleS1;
